<template>
    <van-popup v-model:show="show" style="background: rgba(0,0,0,0);" closeable close-icon="clear">
        <div class="popup-box">
            <div class="content">
                <img class="tztopbg" src="@/assets/images/tztopbg.png" alt="">
                <div class="h1">{{ props.data[0].title }}</div>
                <p class="con">{{ props.data[0].content }}</p>
                <van-button type="default" class="btn" @click="handleReceive">
                    {{ t('notifyPopup.a3') }}
                </van-button>
            </div>
        </div>
    </van-popup>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useI18n } from "vue-i18n"
import { useMainStore } from "@/store"
import { readNoticeApi } from "@/api"

const mainStore = useMainStore()
const { t } = useI18n()

const props = defineProps({
    show: Boolean,
    data: { type: Array, default: () => [] },
    type: { type: String, default: 'System' }
})
console.log(props);


const emit = defineEmits(["update:show"])

const show = ref(props.show)

watch(() => props.show, v => show.value = v)
watch(show, v => emit("update:show", v))
const read = async (idVal: string) => {
    try {
        const res = await readNoticeApi({
            id: idVal
        });
    } catch (error) {
        console.error(error);
    }
};

function handleReceive() {
    if (props.type != "System") {
        // 执行用户通知的已读提交
        const ids = props.data.id
        read(ids)
        mainStore.setRemark(true)
    } else {
        mainStore.setSysMessage(true)
    }
    show.value = false
}
</script>


<style scoped lang="scss">
:deep(.van-badge__wrapper) {
    top: 50px;
    left: calc(100% - 30px);
}

.popup-box {
    width: 90vw;
    max-width: 350px;
    padding-top: 44px;

    .content {
        border-radius: 20px;
        background-color: #FFF;
        position: relative;
        padding-top: 44px;
        padding: 60px 16px 20px 16px;
        background-image: url("@/assets/images/tzbg.png");
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: top;

        .tztopbg {
            width: 90px;
            position: absolute;
            left: 0;
            right: 0;
            top: -44px;
            margin: auto;
        }

        .h1 {
            color: #000;
            text-align: center;
            font-family: "Microsoft YaHei UI";
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-bottom: 12px;
        }

        .con {
            color: #666;
            text-align: center;
            font-family: "Microsoft YaHei UI";
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
        }

        .btn {
            margin-top: 16px;
            width: 100%;
            border-radius: 10px;
            background: #2969FF;
            border-color: #2969FF;
            color: #FFF;
            text-align: center;
            font-family: "Microsoft YaHei UI";
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
    }
}
</style>